import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { BAC_ADMISSION_DATA } from './bacAdmission.data';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { BaseComponent } from '../../base.component';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-admission',
  standalone: true,
  imports: [TranslateModule, RouterOutlet, CommonModule],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './bac-admission.component.html',
  styleUrl: './bac-admission.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacAdmissionComponent extends BaseComponent {
  public ADMISSION_DATA = BAC_ADMISSION_DATA;
  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }
}
